import { FaUserSecret, FaSignOutAlt } from 'react-icons/fa';
import { useAuth } from '../context/AuthContext';

/**
 * Always-visible marker that this tab is a superadmin role preview.
 *
 * Without it, an impersonated tab is indistinguishable from a real session -
 * which makes it far too easy to take an action believing you are yourself, or
 * to mistake test data for production data.
 */
const ImpersonationBanner = () => {
  const { isImpersonating, impersonation, user, endImpersonation } = useAuth();

  if (!isImpersonating) return null;

  const roleLabel = user?.role ? user.role.charAt(0).toUpperCase() + user.role.slice(1) : 'role';

  return (
    <div className="sticky top-0 z-[60] bg-amber-500 text-white shadow-sm print:hidden">
      <div className="max-w-7xl mx-auto px-4 py-2 flex flex-wrap items-center justify-between gap-2">
        <div className="flex items-center gap-2 min-w-0">
          <FaUserSecret className="h-4 w-4 shrink-0" />
          <span className="text-sm font-semibold">
            Previewing as {roleLabel}
          </span>
          <span className="text-xs text-white/80 truncate">
            {user?.name}
            {user?.email ? ` · ${user.email}` : ''}
            {impersonation?.by ? ` · opened by ${impersonation.by}` : ''}
          </span>
        </div>
        <button
          type="button"
          onClick={endImpersonation}
          className="inline-flex items-center gap-1.5 px-3 py-1 rounded-lg bg-white/20 hover:bg-white/30 transition-colors text-xs font-semibold shrink-0"
          title="End this preview (only affects this tab)"
        >
          <FaSignOutAlt className="h-3 w-3" />
          Exit preview
        </button>
      </div>
    </div>
  );
};

export default ImpersonationBanner;
